import React from "react";
import { Modal, ModalHeader, Col, Row } from "reactstrap";
//import { FormIndicationExam} from './FormIDcard'
import { FormIDcard } from "./FormIDcard";
import "../../../assets/css/pantalla1.css";
import { height } from "@mui/system";
import { Dialog } from 'primereact/dialog';


export const ModalIDcard = (props) => {
  const {
    method,
    modalTitle,
    closeModal,
    modal,
    loading,
    getDataNim,
    data,
    handleInputChangeNim,
    nim,
  } = props;

  return (
    <Dialog
      header={modalTitle ?? "---"}
      visible={modal}
      headerStyle={{
        backgroundColor: "#0d3b59",
        color: 'white',
        fontWeight: 'bold',
      }}
      pt={{
        header: { style: { backgroundColor: "#0d3b59", color: 'white' } },
        headerIcon: { style: { color: 'white' } },
      }}
      onHide={closeModal}
      className="medium-dialog"

    >
      {method === "list" ? (
        <FormIDcard
          button="Guardar"
          {...{ closeModal, loading, getDataNim, data, handleInputChangeNim, nim }}
        />
      ) : (
        method === "update"
      )}

    </Dialog>

  );
};
